import { IxTabs } from './IxTabs.js';

window.customElements.define('ix-tabs', IxTabs);
